import Compressor from 'compressorjs';

const readAsDataURL = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(new Error('FileReader error'));
  });

// Compress the image and stamp the "HotelX use only" watermark, resolving with
// the resulting blob. Everything is scoped to this call so concurrent uploads
// (e.g. Front and Back) never share state.
const watermark = (file: File): Promise<Blob> =>
  new Promise((resolve, reject) => {
    // eslint-disable-next-line no-new
    new Compressor(file, {
      strict: false,
      drew(context: any, canvas: any) {
        const fontSize = canvas.height * 0.2;
        context.fillStyle = '#000';
        context.font = `${fontSize}px serif`;
        context.textAlign = 'center';
        context.fillText('HotelX use only', canvas.width / 2, canvas.height / 2);
      },
      success(result: any) {
        resolve(result);
      },
      error(err) {
        reject(err);
      },
    });
  });

export const OCRhelper = async (file: File) => {
  const watermarkedBlob = await watermark(file);
  const picture = await readAsDataURL(watermarkedBlob);
  const base64 = picture.split('base64,')[1];
  return { base64, picture, Blob: watermarkedBlob };
};

export function b64toBlob(b64Data: any, contentType: any, sliceSize: any) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  let byteArrays: any = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    let byteArray: any = new Uint8Array(byteNumbers) as any;
    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, { type: contentType });
}
